import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-primary-light/50 pt-24 pb-12 border-t border-primary-dark/5" data-id="element-41">
      <div className="container mx-auto px-6" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20" data-id="element-43">
          <div className="lg:col-span-1" data-id="element-44">
            <div className="mb-6" data-id="element-45">
              <Link to="/" data-id="element-46">
                <img src="https://cdn.magicpatterns.com/uploads/gniRXuhgWi11P326tXmzet/accutemp-logo-colour.svg" alt="AccuTemp Air Conditioning" className="h-10 w-auto" data-id="element-47" />
              </Link>
            </div>
            <p className="text-xs text-primary-dark/60 leading-relaxed mb-8 max-w-xs" data-id="element-48">
              AccuTemp is Nuneaton's leading commercial HVAC specialist. With
              over 16 years of experience and Daikin D1+ Premier Partner status,
              we deliver installation, maintenance, and compliance services
              built to last.
            </p>
            <a href="/#contact" className="inline-block bg-primary-dark hover:bg-primary-dark/90 text-white text-sm px-6 py-2.5 rounded-full transition-colors" data-id="element-49">
              Contact us
            </a>
          </div>

          <div data-id="element-50">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-51">
              Services
            </h4>
            <ul className="space-y-4 text-sm text-primary-dark/70" data-id="element-52">
              <li data-id="element-53">
                <a href="/#services" className="hover:text-accent transition-colors" data-id="element-54">
                  Installation
                </a>
              </li>
              <li data-id="element-55">
                <a href="/#services" className="hover:text-accent transition-colors" data-id="element-56">
                  Maintenance
                </a>
              </li>
              <li data-id="element-57">
                <a href="/#services" className="hover:text-accent transition-colors" data-id="element-58">
                  FM & ad-hoc support
                </a>
              </li>
              <li data-id="element-59">
                <a href="/#services" className="hover:text-accent transition-colors" data-id="element-60">
                  TM44 compliance
                </a>
              </li>
              <li data-id="element-61">
                <Link to="/knowledge-hub" className="hover:text-accent transition-colors" data-id="element-62">
                  Knowledge hub
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-63">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-64">
              Company
            </h4>
            <ul className="space-y-4 text-sm text-primary-dark/70" data-id="element-65">
              <li data-id="element-66">
                <a href="/#why-us" className="hover:text-accent transition-colors" data-id="element-67">
                  About AccuTemp
                </a>
              </li>
              <li data-id="element-68">
                <a href="/#why-us" className="hover:text-accent transition-colors" data-id="element-69">
                  Accreditations
                </a>
              </li>
              <li data-id="element-70">
                <a href="/#case-studies" className="hover:text-accent transition-colors" data-id="element-71">
                  Case studies
                </a>
              </li>
              <li data-id="element-72">
                <a href="/#why-us" className="hover:text-accent transition-colors" data-id="element-73">
                  Why choose us
                </a>
              </li>
              <li data-id="element-74">
                <a href="/#contact" className="hover:text-accent transition-colors" data-id="element-75">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-76">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-77">
              Contact
            </h4>
            <div className="space-y-5" data-id="element-78">
              <a href="https://maps.google.com/?q=Unit+7+Bermuda+Trade+Centre+Nuneaton+CV10+7RA" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm text-primary-dark/70 hover:text-accent transition-colors" data-id="element-79">
                <img src="https://cdn.magicpatterns.com/uploads/nNB1suhFNGfe5KE3vMugN2/contact-pin.svg" alt="" className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-80" />
                <span data-id="element-81">
                  Unit 7, Bermuda Trade Centre,
                  <br data-id="element-82" />
                  Nuneaton, CV10 7RA
                </span>
              </a>
              <a href="https://linkedin.com/company/accutemp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-primary-dark/70 hover:text-accent transition-colors" data-id="element-83">
                <img src="https://cdn.magicpatterns.com/uploads/mWtzq8HpugEAB5Agb6tRuc/contact-linkedin.svg" alt="LinkedIn" className="w-5 h-5 flex-shrink-0" data-id="element-84" />
                <span data-id="element-85">Follow us on LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-primary-dark/10 text-xs text-primary-dark/50" data-id="element-86">
          <div className="mb-4 md:mb-0" data-id="element-87">
            Copyright © AccuTemp Air Conditioning Ltd 2026
          </div>
          <div className="flex items-center gap-6" data-id="element-88">
            <a href="/cookies" className="hover:text-primary-dark transition-colors" data-id="element-89">
              Cookies
            </a>
            <a href="/privacy" className="hover:text-primary-dark transition-colors" data-id="element-90">
              Privacy policy
            </a>
            <a href="/gdpr" className="hover:text-primary-dark transition-colors" data-id="element-91">
              GDPR
            </a>
          </div>
        </div>
      </div>
    </footer>;
}